import React, { useEffect, useState } from 'react'
import Carousel from '../../Components/Slider/Carousel'
import { Ads, AdsImage, Strong, Overlay, AbsoluteTitle, AbsoluteDiv, Details, DetailsContainer, DetailsTitle, DetailsContent, DetailsButton, Car, CarImg, ContainerWithPic, GalleryContainer, Teams, Team, TeamWrapper, AdsOverlay, AdsContent, AdsExp, AdsTitle, AdsTitleStrong, ContactBtn } from '../../GlobalStyles'
import ads_bg from "../../Images/valeria2.jpg";
import "./Fix.css";
import car from "../../Images/car.png";

import GridGallery from '../../Components/GridGallery/GridGallery';
import Prices from '../../Components/Prices/Prices';
import Skills from '../../Components/Skills/Skills';
import SecondRight from '../../Components/Lines/SecondRight';
import TopLine from '../../Components/Lines/TopLine';
import Contacts from '../../Components/Contacts/Contacts';


const Home = (props) => {

  const [data, setData] = useState(null);

  const getData = () => {
    fetch('settings.json'
      , {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    ).then(function(response){
      return response.json();
    })
    .then(function(myJson) {
      setData(myJson.Components);
    });
  }
  useEffect(() => {
    getData()
  }, [])

  return (
    <React.Fragment>
      {
        data && 
        <React.Fragment>
          <ContainerWithPic>
            <Overlay />

            <Carousel props={data.Carousel} />

            <DetailsContainer light large> 
              <TopLine />
              <CarImg src={car} />
              <Details>
                <DetailsTitle>Kami details<Strong br> & Informations</Strong></DetailsTitle>
                <DetailsContent>
                  {data.Info.Description}
                </DetailsContent>
                <Teams>
                  {
                    data.Info.Teams.map(
                      x => {
                        return (
                          <TeamWrapper href={x.TeamLink}>
                            <Team src={x.TeamLogo} />
                            {x.TeamName}
                          </TeamWrapper>
                        )
                      }
                    )
                  }
                </Teams>
                <DetailsButton href={data.Info.Link}>View more</DetailsButton>
              </Details>
            </DetailsContainer>

            <Skills props={data.Skills}/>
            <Prices props={data.Prices}/>

            <GalleryContainer large>
              <SecondRight />
              <AbsoluteDiv>
                <AbsoluteTitle hide light> View more </AbsoluteTitle>
                <AbsoluteTitle> Galleries </AbsoluteTitle>
              </AbsoluteDiv>
              <GridGallery props={data.GridGallery} />
            </GalleryContainer>
          </ContainerWithPic>

          <Ads>
            <AdsImage img={ads_bg} />
            <AdsOverlay />
            <AdsContent>
              <AdsExp>Your dream is our dream</AdsExp>
              <AdsTitle>We’re ready to <AdsTitleStrong>start creating</AdsTitleStrong> great builds for you.</AdsTitle>
              <ContactBtn href="/#/portfolio">Our Portfolio</ContactBtn>
            </AdsContent>
          </Ads>

          <Contacts props={data.Contact}/>
        </React.Fragment>
      }

    </React.Fragment>
  )
}

export default Home